<template>
  <rest-form-item :label="tooltip ? '' : label" :prop="prop">
    <el-select
      v-model="model"
      filterable
      remote
      :placeholder="placeholder || $t('Segment_Placeholder')"
      :remote-method="fetchSegmentsDropdown"
      :clearable="clearable"
      v-loading="loadingSegments"
      :disabled="readOnly"
      data-qa="segment-select-input"
      @change="$emit('change')"
    >
      <el-option
        v-if="placeholder"
        :value="null"
        :label="placeholder || $t('Segment_Placeholder')"
      />
      <el-option-group v-if="predefined" :label="$t('Segment_Predefined')">
        <el-option
          v-if="predefined && predefined.length > 0"
          v-for="item in predefined"
          :key="item.id"
          :label="item.title"
          :value="item.id"
        />
      </el-option-group>
      <el-option-group v-if="predefined" :label="$t('Segment_User_Created')">
        <el-option
          v-for="item in segments"
          :key="item.id"
          :label="item.title"
          :value="item.id"
        />
      </el-option-group>
      <el-option
        v-else
        v-for="item in segments"
        :key="item.id"
        :label="item.title"
        :value="item.id"
      />
    </el-select>
    <template v-if="tooltip" #label>
      {{ label }}
      <form-item-i-tooltip :tooltip-content="tooltip" />
    </template>
  </rest-form-item>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'
import FormItemITooltip from '@/common/components/form/FormItemITooltip.vue'
import RestApi from '@/core/services/RestApi'
import { RestApiPaginator } from '@/core/utils/RestApiPaginator'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'SegmentSelect',

  components: {
    FormItemITooltip,
    RestFormItem
  },

  data() {
    return {
      loadingSegments: true,
      segments: {}
    }
  },

  props: {
    prop: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: [Boolean, String],
      required: false,
      default: false
    },
    tooltip: {
      type: [Boolean, String],
      required: false,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    predefined: {
      type: [Boolean, Array],
      required: false
    }
  },

  mounted() {
    this.fetchSegments()
  },

  computed: {
    model: {
      get() {
        if (this.value && Number.isInteger(this.value)) {
          return parseInt(this.value)
        }

        return undefined
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    fetchSegments() {
      this.loadingSegments = true
      const params = {
        'per-page': 50
      }

      if (this.value) {
        params.include_id = this.value
      }

      new RestApiPaginator(
        projectEndpoint({
          method: 'get',
          url: `segments`,
          params: params
        })
      )
        .fetchPage(1)
        .then(({ data }) => {
          this.segments = data
          this.loadingSegments = false
        })
    },

    fetchSegmentsDropdown(query) {
      this.loadingSegments = true

      let params = { sort: 'title', 'per-page': 50 }

      if (query !== null && query !== '') {
        params.title = query
      }

      let endpoint = projectEndpoint({
        method: 'get',
        url: 'segments',
        params: params
      })

      RestApi(endpoint)
        .then(({ data }) => {
          this.segments = data
          this.loadingSegments = false
        })
        .catch(error => {
          this.loadingSegments = false
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/segment/SegmentSelect.vue